import { render } from "./LpPositions.vue?vue&type=template&id=d6927134"
import script from "./LpPositions.vue?vue&type=script&lang=js"
export * from "./LpPositions.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/defi/LpPositions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d6927134"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d6927134', __exports__)) {
    api.reload('d6927134', __exports__)
  }
  
  module.hot.accept("./LpPositions.vue?vue&type=template&id=d6927134", () => {
    api.rerender('d6927134', render)
  })

}


export default __exports__